module.exports = __webpack_public_path__ + "static/media/parallax-bg-3.fe77ad16.jpg";